import React from "react";
import smallHeadShot from "../../../img/headshot3.jpg";

const Photo = () => {
  return (
    <div className="head-shot">
      <img src={smallHeadShot} alt="problem loading: headshot" />
    </div>
  );
};

export default Photo;
